// 페이지 가이드(온보딩 투어) 매니저 — Shepherd.js 11 래퍼
// - useModalOverlay:true 로 대상 스포트라이트 + 나머지 암막
// - 첫 방문 시 자동 1회(maybeAutoStart), 제목 옆 ? 버튼으로 강제 재생(startGuide force)
import Shepherd from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';
import './guide.scss';
import { reactLocalStorage as Storage } from 'reactjs-localstorage';
import { getTourBuilder } from './tourRegistry';

// 투어 콘텐츠가 크게 바뀌면 올려서 사용자에게 다시 노출
const VERSION = 'v1';

const seenKey = (key, ctx) => `orp_guide_seen_${(ctx && ctx.storeId) || 'g'}_${key}_${VERSION}`;

export const isSeen = (key, ctx) => !!Storage.get(seenKey(key, ctx), '');
export const markSeen = (key, ctx) => Storage.set(seenKey(key, ctx), '1');

let activeTour = null;

function buildTour(key, ctx) {
  const builder = getTourBuilder(key);
  if (!builder) return null;

  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      classes: 'orp-guide',
      scrollTo: { behavior: 'smooth', block: 'center' },
      // 어드민 레이아웃은 window 가 아니라 .contents 컨테이너가 스크롤됨 → Shepherd 기본 스크롤이
      // 깊은 위치 타깃에 동작하지 않아, scrollIntoView 로 직접 스크롤(가까운 스크롤 조상 자동 처리).
      scrollToHandler: (el) => { try { if (el && el.scrollIntoView) el.scrollIntoView({ block: 'center' }); } catch (e) {} }, // smooth 는 .contents 에서 동작 안 함 → instant
      cancelIcon: { enabled: true },
      modalOverlayOpeningPadding: 6,
      modalOverlayOpeningRadius: 10,
      arrow: true,
    },
  });

  const steps = builder(ctx, tour) || [];
  steps.forEach((s) => tour.addStep(s));
  return tour;
}

// 투어 시작. force=false(자동)일 땐 본 적 없을 때만, force=true(? 버튼)는 무조건.
export function startGuide(key, ctx = {}, opts = {}) {
  try {
    if (!opts.force && isSeen(key, ctx)) return null;

    if (activeTour) {
      try { activeTour.cancel(); } catch (e) { /* noop */ }
      activeTour = null;
    }

    const tour = buildTour(key, ctx);
    if (!tour || !tour.steps || tour.steps.length === 0) return null;

    const done = () => { markSeen(key, ctx); activeTour = null; };
    tour.on('complete', done);
    tour.on('cancel', done);

    activeTour = tour;
    tour.start();
    return tour;
  } catch (e) {
    // 가이드는 보조 기능 — 실패해도 페이지 동작을 막지 않는다.
    if (typeof console !== 'undefined') console.warn('[guide] start failed:', e);
    return null;
  }
}

// 첫 방문 자동 시작
export function maybeAutoStart(key, ctx = {}) {
  if (isSeen(key, ctx)) return null;
  return startGuide(key, ctx, { force: false });
}

const guideManager = { startGuide, maybeAutoStart, isSeen, markSeen };
export default guideManager;
